import React from 'react';
import EventDetail from '../../../components/event/eventDetailPage';

const EventDetailPage = () => {
  return (
    <>
      <EventDetail />
    </>
  );
};

export default EventDetailPage;
